// Arrives Later bonus line. An arrives-later Aracna line carries _zs_drop and _zs_preorder (gift | credit). On every page,
// keep exactly one matching $0 bonus line (unlisted products, handles "zs-bonus-") while such a line is in the cart, and
// none once it's gone. Works however the item was added (Kaching's widget or the theme form), because it reacts to the cart.
(() => {
  if (window.__zsBonusGuard) return;
  window.__zsBonusGuard = true;
  const tag = document.querySelector('script[data-zs-bonus-gift]');
  const variants = { gift: Number(tag?.dataset.zsBonusGift) || 0, credit: Number(tag?.dataset.zsBonusCredit) || 0 };
  const isBonus = (item) => (item.handle || '').startsWith('zs-bonus-');
  const json = { 'Content-Type': 'application/json', Accept: 'application/json' };
  let busy = false;

  const check = async (cart) => {
    if (busy) return;
    busy = true;
    try {
      if (!cart || !Array.isArray(cart.items)) cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      const later = cart.items.find((item) => !isBonus(item) && item.properties && item.properties._zs_drop);
      const want = later ? variants[later.properties._zs_preorder] : 0;
      const bonus = cart.items.filter(isBonus);
      const updates = {};
      let keep = false;
      bonus.forEach((item) => {
        const ok = want && !keep && item.variant_id === want;
        if (ok) keep = true;
        const qty = ok ? 1 : 0;
        if (item.quantity !== qty) updates[item.key] = qty;
      });
      let changed = false;
      if (Object.keys(updates).length) {
        await fetch('/cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates }) });
        changed = true;
      }
      if (want && !keep) {
        const properties = { _zs_bonus: later.properties._zs_preorder, _zs_drop: later.properties._zs_drop };
        await fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: want, quantity: 1, properties }] }) });
        changed = true;
      }
      if (changed) document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
    } catch (e) {
      // Never block the cart over this; the release script's audit catches strays.
    } finally {
      busy = false;
    }
  };

  // Apps (Kaching) add to the cart with their own fetch and don't always publish the theme's cart event: watch cart
  // requests too. Our own requests run while busy, so they don't retrigger.
  const nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input?.url || '';
    const result = nativeFetch.apply(this, arguments);
    if (!busy && /\/cart\/(add|change|update|clear)/.test(url)) result.then(() => setTimeout(() => check(), 300)).catch(() => {});
    return result;
  };

  const start = () => {
    check();
    if (window.theme?.pubsub) theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, () => setTimeout(() => check(), 50));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
